let instance;

const STICKY_MENU_OFFSET = -74;

export default async function asyncSweetScroll(target, offset = 0) {
  const { default: SweetScroll } = await import(
    /* webpackChunkName: "sweet-scroll" */ 'sweet-scroll'
  );

  if (!instance) {
    instance = new SweetScroll();
  }
  const node = typeof target === 'string' ? document.querySelector(target) : target?.[0] ?? target;

  // SweetScroll двигает scrollTop покадрово, а браузер при `scroll-behavior: smooth`
  // (его ставит на html сборка Tabler в админке) каждый такой шаг превращает в
  // собственную плавную прокрутку: страница почти стоит на месте, а доезжает уже
  // после анимации. Своё значение снимаем на время анимации — inline-свойства
  // scroll-behavior в проекте нет, поэтому вернуть его = удалить своё
  document.documentElement.style.scrollBehavior = 'auto';

  instance.toElement(
    node,
    {
      duration: 750,
      offset: offset || STICKY_MENU_OFFSET - 6,
      complete: () => document.documentElement.style.removeProperty('scroll-behavior')
    }
  );
}
